
const Prompter = (function () {

    let init = function(config, confirmCallback, cancelCallback)
    {
        if (typeof confirmCallback === 'undefined') {
            confirmCallback = false;
        }

        if (typeof cancelCallback === 'undefined') {
            cancelCallback = false;
        }

        $.confirm({
            //icon: config.hasOwnProperty('icon') ? config.icon : 'fa-duotone fa-exclamation-triangle',
            closeIcon: false,
            escapeKey: true,
            backgroundDismiss: true,
            columnClass: 'col-md-12',
            containerFluid: true,
            title:  config.hasOwnProperty('title') ? config.title : 'Do you want to continue?',
            content: config.hasOwnProperty('content') ? config.content : 'This action may can not be undone!',
            type: config.hasOwnProperty('type') ? config.type : 'red',
            typeAnimated: true,
            theme: config.hasOwnProperty('theme') ? config.theme : 'supervan',
            draggable: false,
            buttons: {
                confirm: {
                    text: config.hasOwnProperty('confirm_text') ? config.confirm_text : 'Continue',
                    btnClass: config.hasOwnProperty('confirm_btn_class') ? config.confirm_btn_class : 'btn-success',
                    action: confirmCallback
                },
                cancel: {
                    btnClass: config.hasOwnProperty('cancel_btn_class') ? config.cancel_btn_class : 'btn-danger',
                    text: config.hasOwnProperty('cancel_text') ? config.cancel_text : 'Cancel',
                },
            }
        });
    };

    return {
        init: init
    }
})();

window.Prompter = Prompter;
